"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LanguageSelect = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactRedux = require("react-redux");
var _core = require("@material-ui/core");
var _locale = require("../../utils/locale");
var _hooks = require("../../hooks");
var _rcPreferences = require("../../state/entities/rcPreferences");
var _Translated = _interopRequireDefault(require("../Translated"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const LanguageSelect = () => {
  const {
    locale
  } = (0, _hooks.useConfig)();
  const dispatch = (0, _reactRedux.useDispatch)();
  const handleChange = e => {
    const updatedLocale = e.target.value;
    dispatch(_rcPreferences.rcPreferencesActions.inject({
      locale: updatedLocale
    }));
  };
  return /*#__PURE__*/_react.default.createElement(_core.FormControl, {
    fullWidth: true
  }, /*#__PURE__*/_react.default.createElement(_core.InputLabel, null, /*#__PURE__*/_react.default.createElement(_Translated.default, {
    id: "language"
  })), /*#__PURE__*/_react.default.createElement(_core.Select, {
    value: locale,
    onChange: handleChange
  }, _locale.supportedLocales.map(localeOption => /*#__PURE__*/_react.default.createElement(_core.MenuItem, {
    key: localeOption,
    value: localeOption
  }, _locale.localeNamesMapping[localeOption]))));
};
exports.LanguageSelect = LanguageSelect;